module.exports = __webpack_public_path__ + "static/media/btn-rifas.fb186fec.png";